import { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";

import Sidebar from "../utilities/Sidebar";

import { changeNav, updateUser } from "../../../redux/actions/userActions";

import Timer from "./dashboard/Timer";
import CleanproHeader from "./dashboard/header/cleanproHeader";
import LaundroHeader from "./dashboard/header/laundroHeader";
import WashupHeader from "./dashboard/header/washupHeader";
import CleanproDashboaardBody from "./dashboard/body/cleanproDashboardBody";
import LaundroDashboardBody from "./dashboard/body/laundroDashboardBody";
import { getStoreType } from "../../../dynamicController";

const STORETYPE = getStoreType()

const Dashboard = ({ user, history, changeNav, token, updateUser, transactionId, transactionType, country }) => {
  const [toggled, setToggled] = useState(false);

  useEffect(() => {
    let getDashboardData = false
    if (user && token && user.transactions.length <= 0) {
      getDashboardData = true
    } else if (user && token && user.transactions.length > 0) {
      if (transactionId && transactionType && transactionType === "Transaction") {
        if (user.transactions.filter(tran => tran.id === transactionId).length <= 0) {
          getDashboardData = true
        }
      }
    }

    if (getDashboardData) {
      axios.get("/api/user/getDashboard", { headers: { "Content-Type": "application/json", "auth-token": token } })
        .then(res => {
          updateUser({ type: "dashboard", transactions: res.data.transactions })
        })
        .catch(err => {
        })
    }
  }, []);

  const renderTimer = useMemo(() => {
    let timerTransaction = []
    if (user) {
      const userTransaction = user.transactions.filter(tran => tran.status === "Success" && (tran.machine_type === "Washer" || tran.machine_type === "Dryer") && tran.machine_duration && new Date(tran.createdAt).setHours(new Date(tran.createdAt).getHours() + 24) > new Date())
      for (let i = 0; i < userTransaction.length; i++) {
        const machineTran = timerTransaction.filter(tran => tran.machine_name === userTransaction[i].machine_name)
        if (machineTran.length > 0) {
          if (new Date(userTransaction[i].createdAt) > new Date(machineTran[0].createdAt)) {
            timerTransaction = timerTransaction.filter(tran => tran.id !== machineTran[0].id)
            timerTransaction.push(userTransaction[i])
          }
        } else {
          timerTransaction.push(userTransaction[i])
        }
      }

      return (
        timerTransaction.map((tran) => {
          return (
            <Timer key={tran.id} tran={tran} history={history} />
          )
        })
      )
    } else {
      return null
    }
  }, [user, history])

  return (
    <div id="user-dashboard">
      <Sidebar toggled={toggled} setToggled={setToggled} />
      {
        STORETYPE === "cleanpro"
          ? <CleanproHeader user={user} setToggled={setToggled} changeNav={changeNav} />
          : STORETYPE === "washup" || STORETYPE === "jomcuci"
            ? <WashupHeader user={user} setToggled={setToggled} />
            : <LaundroHeader user={user} setToggled={setToggled} />
      }

      {
        STORETYPE === "cleanpro" || STORETYPE === "washup" || STORETYPE === "jomcuci"
          ? <CleanproDashboaardBody user={user} renderTimer={renderTimer} history={history} country={country} />
          : <LaundroDashboardBody user={user} renderTimer={renderTimer} history={history} />
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    token: state.user.token,
    transactionId: state.payment.transactionId,
    transactionType: state.payment.transactionType,
    country: state.user.country,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeNav: (nav) => dispatch(changeNav(nav)),
    updateUser: (data) => dispatch(updateUser(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
